var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowLessArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 0L0 5.33333L1.25333 6.58667L5.33333 2.51556L9.41333 6.58667L10.6667 5.33333L5.33333 0Z",
    fill: "#004895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLessArrow);
export default __webpack_public_path__ + "static/media/ShowLessArrow.26ad43d9822ce95e6a9f97acdd4bbb79.svg";
export { ForwardRef as ReactComponent };